// extracted by mini-css-extract-plugin
module.exports = {"container":"_1BOqG","listItem":"_1rlmq","withFooter":"_2lcVd"};